import { render, staticRenderFns } from "./WorkerReassignPicker.vue?vue&type=template&id=8957a826&"
import script from "./WorkerReassignPicker.vue?vue&type=script&lang=ts&"
export * from "./WorkerReassignPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports